var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from "./BaseModel";
var PaymentAccountModel = /** @class */ (function (_super) {
    __extends(PaymentAccountModel, _super);
    function PaymentAccountModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.id = hydrated.id;
        _this.accountNumber = hydrated.accountNumber;
        _this.accountType = hydrated.accountType;
        _this.addedAccountId = hydrated.addedAccountId;
        _this.address = hydrated.address;
        _this.balance = hydrated.balance;
        _this.crDate = hydrated.crDate;
        _this.encryptedFormat = hydrated.encryptedFormat;
        _this.expiration = hydrated.expiration;
        _this.isCert = hydrated.isCert;
        _this.lastUseDate = hydrated.lastUseDate;
        _this.locationBase = hydrated.locationBase;
        _this.logo = hydrated.logo;
        _this.manualSignatureCollected = hydrated.manualSignatureCollected;
        _this.manualSignatureRequired = hydrated.manualSignatureRequired;
        _this.name = hydrated.name;
        _this.orderId = hydrated.orderId;
        _this.paymentId = hydrated.paymentId;
        _this.postalCode = hydrated.postalCode;
        _this.ppKSN = hydrated.ppKSN;
        _this.ppSignature = hydrated.ppSignature;
        _this.ppTrack1 = hydrated.ppTrack1;
        _this.rawData = hydrated.rawData;
        _this.signatureImg = hydrated.signatureImg;
        _this.transactionIds = hydrated.transactionIds;
        _this.type = hydrated.type;
        return _this;
    }
    PaymentAccountModel.prototype.hydrate = function (data) {
        var paymentAccount = {};
        paymentAccount.id = (typeof data.account_id !== undefined) ? data.account_id : null;
        paymentAccount.accountNumber = data.accountNumber.replace(/\D/g, "") || null;
        paymentAccount.accountType = typeof data.account_type !== undefined ? data.account_type : null;
        paymentAccount.addedAccountId = data.added_account_id || null;
        paymentAccount.address = data.address || null;
        paymentAccount.balance = data.balance || null;
        paymentAccount.crDate = data.cr_date || null;
        paymentAccount.encryptedFormat = data.encryptedFormat || null;
        paymentAccount.expiration = data.expiration || null;
        paymentAccount.isCert = data.is_cert || null;
        paymentAccount.lastUseDate = data.last_use_date || null;
        paymentAccount.locationBase = data.location_base || null;
        paymentAccount.logo = data.logo || null;
        paymentAccount.manualSignatureCollected = data.manual_signature_collected || null;
        paymentAccount.manualSignatureRequired = data.manual_signature_required || null;
        paymentAccount.name = data.name || null;
        paymentAccount.orderId = data.order_id || null;
        paymentAccount.paymentId = data.payment_id || null;
        paymentAccount.postalCode = data.postal_code || null;
        paymentAccount.ppKSN = data.ppKSN || null;
        paymentAccount.ppSignature = data.ppSignature || null;
        paymentAccount.ppTrack1 = data.ppTrack1 || null;
        paymentAccount.rawData = data.rawData || null;
        paymentAccount.signatureImg = data.signatureImg || null;
        paymentAccount.transactionIds = data.transactionIds || null;
        paymentAccount.type = data.type || null;
        return paymentAccount;
    };
    return PaymentAccountModel;
}(BaseModel));
export default PaymentAccountModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/PaymentAccountModel.ts
// module id = m44C
// module chunks = 18